import { render } from "./NotificationSymbol.vue?vue&type=template&id=96a26f66&scoped=true"
import script from "./NotificationSymbol.vue?vue&type=script&lang=js"
export * from "./NotificationSymbol.vue?vue&type=script&lang=js"

import "./NotificationSymbol.vue?vue&type=style&index=0&id=96a26f66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a26f66"]])

export default __exports__